// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YShf","col":"styles_col__2BuHc"};